module.exports = __webpack_public_path__ + "static/media/black_cheerleader.f571aaa7.svg";